import { Star } from "lucide-react";
import { RevealSection } from "@/components/common/RevealSection";
import { testimonials, faqItems } from "@/content/siteData";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function TestimonialsPage() {
  return (
    <div className="px-6 md:px-12 lg:px-24" data-testid="testimonials-page">
      <RevealSection className="mx-auto w-full max-w-7xl py-14 md:py-20">
        <p className="text-base text-primary md:text-lg" data-testid="testimonials-label">
          Learner voices
        </p>
        <h1 className="mt-3 text-4xl font-bold leading-tight sm:text-5xl lg:text-6xl" data-testid="testimonials-heading">
          What students say about learning Hindi with Prabha.
        </h1>

        <div className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((item) => (
            <article
              key={item.name}
              className="rounded-2xl border border-border bg-white p-6 soft-card"
              data-testid={`testimonial-card-${item.name.toLowerCase().replace(/\W+/g, "-")}`}
            >
              <div className="mb-4 flex items-center gap-3" data-testid={`testimonial-header-${item.name.toLowerCase().replace(/\W+/g, "-")}`}>
                {item.avatar ? (
                  <img
                    src={item.avatar}
                    alt={`${item.name} testimonial`}
                    className="h-14 w-14 rounded-full border border-border object-cover object-top"
                    data-testid={`testimonial-avatar-${item.name.toLowerCase().replace(/\W+/g, "-")}`}
                  />
                ) : (
                  <div
                    className="flex h-14 w-14 items-center justify-center rounded-full border border-border bg-muted/40 text-sm font-semibold text-primary"
                    data-testid={`testimonial-avatar-fallback-${item.name.toLowerCase().replace(/\W+/g, "-")}`}
                  >
                    {item.name
                      .split(" ")
                      .slice(0, 2)
                      .map((part) => part[0])
                      .join("")}
                  </div>
                )}
                <div>
                  <p className="text-base font-semibold text-primary" data-testid={`testimonial-name-${item.name.toLowerCase().replace(/\W+/g, "-")}`}>
                    {item.name}
                  </p>
                  <p className="text-sm text-muted-foreground" data-testid={`testimonial-location-${item.name.toLowerCase().replace(/\W+/g, "-")}`}>
                    {item.location}
                  </p>
                </div>
              </div>
              <div className="mb-3 flex items-center gap-1 text-accent" data-testid={`testimonial-stars-${item.name.toLowerCase().replace(/\W+/g, "-")}`}>
                <Star className="h-4 w-4 fill-current" />
                <Star className="h-4 w-4 fill-current" />
                <Star className="h-4 w-4 fill-current" />
                <Star className="h-4 w-4 fill-current" />
                <Star className="h-4 w-4 fill-current" />
              </div>
              <p className="text-sm leading-relaxed text-foreground/90 md:text-base">“{item.feedback}”</p>
            </article>
          ))}
        </div>
      </RevealSection>

      <RevealSection className="mx-auto mb-10 w-full max-w-5xl rounded-2xl border border-border bg-muted/70 p-8" delay={0.15}>
        <h2 className="text-3xl font-semibold text-primary" data-testid="faq-heading">
          Frequently asked questions
        </h2>
        <Accordion type="single" collapsible className="mt-4" data-testid="faq-accordion">
          {faqItems.map((item, index) => (
            <AccordionItem key={item.question} value={`faq-${index}`}>
              <AccordionTrigger data-testid={`faq-trigger-${index}`}>{item.question}</AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${index}`}>{item.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </RevealSection>
    </div>
  );
}